import React from 'react'

import { NavLink } from 'react-router-dom'

import { SiteContext } from 'context/site-context'

import {
  getQS,
  isWebpSupported,
} from 'helpers'

import './index.scss'

const Categories = () => {
  const [ site ] = React.useContext(SiteContext)

  return <React.Fragment>
    {site.categories ? <div className="categories-container" style={{ background: `url(${isWebpSupported() && site.hero?.backgroundImageWebP ? site.hero?.backgroundImageWebP : site.hero?.backgroundImage}) no-repeat center center / cover` }}>
      <div className="container">
        <h2>Popular Searches</h2>
        <div className="categories-wrapper">
          <ul>
            {site.categories.sort().map( category => <li key={category}><a href={`/results?term=${category}&where=${site.location}${getQS().trim().length > 0 ? `${getQS()}` : ''}`}>{category}</a></li>)}
          </ul>
        </div>
      </div>
    </div> : null}
  </React.Fragment>
}

export default Categories
